import { Pipe, PipeTransform } from '@angular/core';
import { StopState } from 'src/app/_models/state/stopState';

@Pipe({ name: 'address' })
export class AddressPipe implements PipeTransform {
  transform(stop: StopState, format: 'full' | 'summary') {
    // TODO add checks for bad/missing data
    if (format === 'summary') {
      return `${stop.location.address.city}, ${stop.location.address.stateAbbreviation} ${stop.location.address.zip}`;
    }
    if (format === 'full' && stop) {
      let addrStr = '';
      addrStr += stop.location.address.streetAddress
        ? `${stop.location.address.streetAddress}, `
        : '';
      addrStr += stop.location.address.city
        ? `${stop.location.address.city}, `
        : '';
      addrStr += stop.location.address.stateAbbreviation
        ? `${stop.location.address.stateAbbreviation} `
        : '';
      addrStr += stop.location.address.zip
        ? `${stop.location.address.zip} `
        : '';
      addrStr += stop.location.address.countryAbbreviation
        ? `, ${stop.location.address.countryAbbreviation}`
        : '';
      return addrStr;
    }
  }
}
